import React, { useEffect, useState } from "react";
import { Menu, X, Languages } from "lucide-react";
import { Button } from "./ui/button";
import { brand, bookingUrl, navHrefs, translations } from "../mock";
import { useLang } from "../i18n/LanguageContext";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { lang, toggle } = useLang();
  const T = translations[lang];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goApp = () => { window.location.href = bookingUrl; };

  const LangToggle = ({ className = "" }) => (
    <button onClick={toggle} aria-label="Switch language"
      className={`inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 h-11 text-sm font-semibold text-navy hover:border-cblue hover:text-cblue transition-colors ${className}`}>
      <Languages className="h-4 w-4" />
      {T.toggleLabel}
    </button>
  );

  return (
    <header className={`fixed top-9 inset-x-0 z-50 transition-all duration-300 ${scrolled ? "bg-white/90 backdrop-blur-md shadow-sm py-2.5" : "bg-transparent py-4"}`}>
      <div className="mx-auto max-w-7xl px-5 md:px-8 flex items-center justify-between">
        <a href="#home" className="flex items-center">
          <img src={brand.logo} alt="CMED.AI" className="h-12 md:h-14 w-auto" />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {T.nav.map((label, i) => (
            <a key={i} href={navHrefs[i]} className="text-sm font-medium text-slate-600 hover:text-navy transition-colors">{label}</a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <LangToggle />
          <Button onClick={goApp} className="bg-navy hover:bg-navy-800 text-white rounded-full px-6 h-11 font-semibold">{T.cta}</Button>
        </div>

        <div className="flex md:hidden items-center gap-2">
          <LangToggle className="!h-10 !px-3" />
          <button className="text-navy" onClick={() => setOpen((v) => !v)} aria-label="Toggle menu">
            {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-slate-100 shadow-lg">
          <div className="px-5 py-4 flex flex-col gap-1">
            {T.nav.map((label, i) => (
              <a key={i} href={navHrefs[i]} onClick={() => setOpen(false)} className="py-3 text-base font-medium text-slate-700 hover:text-navy border-b border-slate-50">{label}</a>
            ))}
            <Button onClick={goApp} className="mt-3 bg-navy hover:bg-navy-800 text-white rounded-full h-12 font-semibold">{T.cta}</Button>
          </div>
        </div>
      )}
    </header>
  );
}
